export default {
      id: "ic_rename_coupon-usage",
      viewBox: "0 0 20 18",
      url: "/" + "images/icons.3.109.2.svg#ic_rename_coupon-usage",
      toString: function () {
        return this.url;
      }
    }